module.exports = __webpack_public_path__ + "static/media/how-rewards-work-step-3.ae9993b9.jpg";